/**
 * Fishermans — abre e fecha o guia "ME AJUDE A ESCOLHER".
 *
 * O CONTEUDO VEM DO LIQUID. Aqui so ha interacao: abrir, fechar, Esc, clique
 * no fundo e travar o scroll da pagina atras. Nada de dado, nada de preco.
 *
 * Delegacao no document porque a PDP re-renderiza o bloco a cada troca de
 * variante (Section Rendering) — listener preso no botao morreria junto.
 */
(function () {
  "use strict";

  var aberta = null;

  function abrir(sid) {
    var g = document.querySelector('[data-fm-guia="' + sid + '"]');
    if (!g) return;
    g.hidden = false;
    /* dois frames: o browser precisa pintar o estado fechado antes da
       transicao, senao a gaveta aparece pronta, sem deslizar */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { g.classList.add("is-aberta"); });
    });
    document.documentElement.classList.add("fm-guia-travada");
    aberta = g;
    var x = g.querySelector(".fm-guia__x");
    if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
  }

  function fechar() {
    if (!aberta) return;
    var g = aberta;
    aberta = null;
    g.classList.remove("is-aberta");
    document.documentElement.classList.remove("fm-guia-travada");
    var fim = function () { g.hidden = true; g.removeEventListener("transitionend", fim); };
    g.addEventListener("transitionend", fim);
    /* rede de seguranca: sem transicao (prefers-reduced-motion, aba em
       segundo plano) o transitionend nunca dispara e a gaveta ficaria
       invisivel por cima da pagina, bloqueando cliques */
    setTimeout(function () { if (!aberta) { g.hidden = true; } }, 400);
  }

  document.addEventListener("click", function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;

    var b = t.closest("[data-fm-guia-abrir]");
    if (b) { evt.preventDefault(); abrir(b.getAttribute("data-fm-guia-abrir")); return; }

    if (t.closest("[data-fm-guia-fechar]")) { evt.preventDefault(); fechar(); }
  });

  document.addEventListener("keydown", function (evt) {
    if (evt.key === "Escape" && aberta) fechar();
  });
})();
